
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import OrganizationsList from "./organization/OrganizationsList";
import OrganizationForm from "./organization/OrganizationForm";
import { OrganizationErrorBoundary } from "./organization/OrganizationErrorBoundary";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const OrganizationManager = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleCreate = () => {
    setIsFormOpen(true);
  };

  const handleFormClose = (createdOrgId?: string) => {
    setIsFormOpen(false);
    // Invalidate the organizations query to refresh the list
    queryClient.invalidateQueries({ queryKey: ['organizations-admin'] });
    
    // Navigate to detail page if org was created
    if (createdOrgId) {
      navigate(`/admin/organizations/${createdOrgId}`);
    }
  };

  return (
    <OrganizationErrorBoundary>
      <div className="space-y-6">
        <div className="bg-white rounded-lg border shadow-sm p-6 space-y-6">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold">Organizations</h2>
              <p className="text-muted-foreground">
                Manage all organizations in the platform
              </p>
            </div>
            <Button onClick={handleCreate}>
              <Plus className="w-4 h-4 mr-2" />
              Create Organization
            </Button>
          </div>

          <OrganizationsList />
        </div>

        <Dialog open={isFormOpen} onOpenChange={setIsFormOpen}>
          <DialogContent 
            className="w-[95vw] max-w-4xl h-[95vh] sm:h-auto sm:max-h-[90vh] p-0" 
            aria-describedby="organization-dialog-description"
          >
            <DialogHeader className="p-6 pb-0">
              <DialogTitle>Create New Organization</DialogTitle>
              <DialogDescription id="organization-dialog-description">
                Create a new organization by providing the required information. After creation, you'll be redirected to manage advanced settings.
              </DialogDescription>
            </DialogHeader>
            <OrganizationForm
              onSuccess={handleFormClose}
              onCancel={() => handleFormClose()}
            />
          </DialogContent>
        </Dialog>
      </div>
    </OrganizationErrorBoundary>
  );
};

export default OrganizationManager;
